export { default } from "./GameInfoBar";
